module.exports = {"370830001":"中都街道","370830002":"汶上街道","370830101":"南站镇","370830102":"南旺镇","370830103":"次丘镇","370830104":"寅寺镇","370830105":"郭楼镇","370830106":"康驿镇","370830107":"苑庄镇","370830108":"义桥镇","370830109":"郭仓镇","370830110":"白石镇","370830111":"杨店镇","370830112":"刘楼镇","370830205":"军屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370830.json
// module id = 1431
// module chunks = 0